import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import config, { googlePayAllowedPaymentMethods } from "../../config";

export function DebugToolGooglePaySnippet() {
    const totalAmount: number = useSelector((state: AppState) => state.cart.totalAmount);

    function onShowTokenRequest() {
        const req = {
            source: 'googlepay',
            paymentMethodData: { token: '<Google Pay token object>' },
        };
        return JSON.stringify(req, null, 1);
    }

    function onShowPaymentRequest() {
        const req = {
            paymentTokenId: '<payment token ID>',
            totalAmount: {
                amount: totalAmount,
                currency: 'PHP',
            },
            buyer: {
                firstName: '<from billing address>',
                middleName: '<from billing address>',
                lastName: '<from billing address>',
                contact: { email: '<from Google Pay>', phone: '<from billing address>' },
                billingAddress: { line1: '', line2: '', city: '', state: '', zipCode: '', countryCode: '' },
                shippingAddress: { line1: '', line2: '', city: '', state: '', zipCode: '', countryCode: '', firstName: '', lastName: '', phone: '', email: '' },
            },
            requestReferenceNumber: uuidv4(),
            redirectUrl: {
                success: `${config.host_url}/purchase/success/?id=<requestReferenceNumber>`,
                failure: `${config.host_url}/purchase/failed/?id=<requestReferenceNumber>`,
                cancel: `${config.host_url}/purchase/canceled/?id=<requestReferenceNumber>`,
            },
        };
        return JSON.stringify(req, null, 1);
    }

    function onShowPaymentDataRequest() {
        const req = {
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: googlePayAllowedPaymentMethods,
            merchantInfo: {
                merchantId: config.google_pay.maya_merchant_id,
                merchantName: config.google_pay.merchant_name,
            },
            transactionInfo: {
                totalPriceStatus: 'FINAL',
                totalPrice: totalAmount.toFixed(2),
                currencyCode: 'PHP',
                countryCode: 'PH',
            },
        };
        return JSON.stringify(req, null, 1);
    }

    return (
        <div className="snippet-container">
            <h4>PaymentDataRequest (sent to Google Pay)</h4>
            <pre>{onShowPaymentDataRequest()}</pre>
            <h4>Payment Token Request (Step 1)</h4>
            <pre>{onShowTokenRequest()}</pre>
            <h4>Payment Request (Step 2)</h4>
            <pre>{onShowPaymentRequest()}</pre>
        </div>
    )
}
